import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { usePluginLoader } from "../../hooks/usePluginLoader";
import TransactionDetails from "./TransactionDetails/TransactionDetails";
import PageLayout from "../../layouts/PageLayout"; // Import the extracted template
import "./Home.css";

interface HomeProps {
  config: any;
}

const Home: React.FC<HomeProps> = ({ config }) => {
  const navigate = useNavigate();
  const { paymentData, brandingStatus } = usePluginLoader(config);

  useEffect(() => {
    // Detect refresh using Performance API
    const [navigationEntry] = performance.getEntriesByType("navigation") as PerformanceNavigationTiming[];

    if (navigationEntry?.type === "reload") {
      // navigate("/error", { replace: true }); // Redirect to error page
    }
  }, [navigate]);

  return (
    <PageLayout
      logoURL={paymentData?.merchantStyling?.logo}
      brandingStatus={brandingStatus}
    >
      {/* Transaction Details Component */}
      <TransactionDetails paymentData={paymentData} />

      {/* Payment iframe */}
      <div className="iframe-container" id="divId"></div>
    </PageLayout>
  );
};

export default Home;
